<template>
  <v-dialog v-model="dialog" max-width="600" persistent>
    <v-card>
      <v-card-title class="text-h5 primary white--text">
        <v-icon left dark>mdi-credit-card</v-icon>
        {{ isEdit ? "Edit" : "Add" }} Payment Method
      </v-card-title>

      <v-card-text class="pt-6">
        <v-form ref="form" v-model="valid">
          <v-select
            v-model="formData.type"
            :items="paymentTypes"
            label="Payment Type"
            :rules="[rules.required]"
            outlined
            dense
          >
            <template v-slot:prepend>
              <v-icon>{{ getPaymentIcon(formData.type) }}</v-icon>
            </template>
          </v-select>

          <v-expand-transition>
            <div v-if="formData.type === 'insurance'">
              <v-text-field
                v-model="formData.insurance_provider"
                label="Insurance Provider"
                :rules="[rules.required]"
                outlined
                dense
              ></v-text-field>

              <v-text-field
                v-model="formData.insurance_policy_number"
                label="Policy Number"
                :rules="[rules.required]"
                outlined
                dense
              ></v-text-field>

              <v-text-field
                v-model="formData.insurance_expiry"
                label="Expiry Date"
                type="date"
                outlined
                dense
              ></v-text-field>
            </div>
          </v-expand-transition>

          <v-textarea
            v-model="formData.payment_terms"
            label="Payment Terms / Notes"
            outlined
            dense
            rows="3"
          ></v-textarea>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="closeDialog"> Cancel </v-btn>
        <v-btn color="primary" @click="savePaymentMethod" :disabled="!valid">
          <v-icon left>mdi-content-save</v-icon>
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "PaymentMethodDialog",

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    paymentMethod: {
      type: Object,
      default: null,
    },
  },

  data: () => ({
    valid: false,
    formData: {
      type: "cash",
      insurance_provider: "",
      insurance_policy_number: "",
      insurance_expiry: "",
      payment_terms: "",
    },
    paymentTypes: [
      { text: "Cash", value: "cash" },
      { text: "Credit/Debit Card", value: "card" },
      { text: "Insurance", value: "insurance" },
      { text: "Bank Transfer", value: "bank_transfer" },
      { text: "Cheque", value: "cheque" },
      { text: "Mobile Money", value: "mobile_money" },
    ],
    rules: {
      required: (v) => !!v || "This field is required",
    },
  }),

  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },

    isEdit() {
      return this.paymentMethod !== null;
    },
  },

  watch: {
    value(val) {
      if (val && this.paymentMethod) {
        this.formData = { ...this.paymentMethod };
      } else if (val) {
        this.resetForm();
      }
    },
  },

  methods: {
    getPaymentIcon(type) {
      const icons = {
        cash: "mdi-cash",
        card: "mdi-credit-card",
        insurance: "mdi-shield-check",
        bank_transfer: "mdi-bank-transfer",
        cheque: "mdi-checkbook",
        mobile_money: "mdi-cellphone",
      };

      return icons[type] || "mdi-cash-multiple";
    },

    savePaymentMethod() {
      if (this.$refs.form.validate()) {
        this.$emit("save", this.formData);
        this.closeDialog();
      }
    },

    closeDialog() {
      this.$emit("input", false);
      this.$emit("close");
      this.resetForm();
    },

    resetForm() {
      this.formData = {
        type: "cash",
        insurance_provider: "",
        insurance_policy_number: "",
        insurance_expiry: "",
        payment_terms: "",
      };
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
  },
};
</script>
